import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/acafc4656fe8f0effa93a4d194df7197df192b2d2f236e1d005780cad536cf8a?apiKey=59156c16963f46e28d2e0d857e2bfa45&" alt="Company Logo" className="logo" />
      <nav className="footer-nav">
        <ul>
          <li><a href="/">Accueil</a></li>
          <li><a href="/formations">Formations</a></li>
          <li><a href="/calendrier">Calendrier</a></li>
        </ul>
      </nav>
      <nav className="footer-nav">
        <ul>
          <li><a href="/qui-sommes-nous">Qui sommes-nous</a></li>
          <li><a href="/avis">Avis</a></li>
          <li><a href="/contact">Contact</a></li>
          <li><a href="/CGU">CGU</a> / <a href="/CGV">CGV</a></li>
        </ul>
      </nav>
      <address className="footer-address">
        <p><a href="mailto:contact@scfps.fr">CONTACT@SCFPS.FR</a></p>
        <p><a href="tel:0951092832">TÉLÉPHONE : 09.51.09.28.32</a></p>
      </address>
    </div>
    <div className="footer-bottom">
      <p className="footer-copyright">©SC-FPS. Tous droits réservés. Déclaration d'activité enregistrée sous le numéro 32 59 09351 59 auprès du préfet de région d'Hauts-de-France</p>
    </div>
  </footer>
);

export default Footer;